
import { useNavigate } from 'react-router-dom';

import '../styles/EmployeeMaster.css';
import PaygroupTable from '../components/PaygroupTable';

const Paygroup = () => {
  const navigate = useNavigate();

  const handleAddClick = () => {
    
    navigate('/paygroup/add');
  };

  

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Paygroup Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Paygroup
        </button>
      </div>

      <PaygroupTable />
    </div>
  );
};

export default Paygroup;